var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9188 0H6.68877H1.07877C0.118772 0 -0.361228 1.16 0.318772 1.84L5.49877 7.02C6.32877 7.85 7.67877 7.85 8.50877 7.02L10.4788 5.05L13.6888 1.84C14.3588 1.16 13.8788 0 12.9188 0Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupDropdown);
export default __webpack_public_path__ + "static/media/signup-dropdown.5a69db722c3fd04d289b10ab821f77c2.svg";
export { ForwardRef as ReactComponent };